import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Container, Button, Column, Row, Select, TextInput, Checkbox } from '@pella/sash-framework';
import styles from './index.module.scss';
import EloquaForm from '../../eloqua-form';
import { isValidEmail } from '../../../utilities/validations';
import { eloquaTrackingUrl } from '../../../utilities/constants';

const EmailPreferenceForm = ({ data }) => {
	const [values, setValues] = useState({
		emailPromo: false,
		emailNewsletter: false,
		unsubscribe: false,
		customerType: '0',
	});
	const [errors, setErrors] = useState({});
	const [disabled, setDisabled] = useState(false);
	const [success, setSuccess] = useState(false);
	const [update, setUpdate] = useState(false);
	const [occurOnce, setOccurOnce] = useState(true);

	useEffect(() => {
		if (update) {
			setUpdate(false);
		}
	}, [update]);

	useEffect(() => {
		if ((values.emailPromo && !values.emailNewsletter) || (!values.emailPromo && values.emailNewsletter && !occurOnce)) {
			setOccurOnce(true);
		}
		if ((values.emailPromo || values.emailNewsletter) && occurOnce) {
			setValues({
				...values,
				unsubscribe: false,
			});
			setOccurOnce(false);
		}
		if (values.unsubscribe === 1 && (values.emailPromo || values.emailNewsletter)) {
			setValues({
				...values,
				emailPromo: false,
				emailNewsletter: false,
			});
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, [values]);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.eloquaPrefData = window.eloquaPrefData || {};

			if (window.eloquaPrefData) {
				setValues({
					firstName: window.eloquaPrefData.C_FirstName,
					lastName: window.eloquaPrefData.C_LastName,
					emailAddress: window.eloquaPrefData.C_EmailAddress,
					zipPostal: window.eloquaPrefData.C_Zip_Postal,
					emailPromo: window.eloquaPrefData.C_Do_Not_Email___Promotional1,
					emailNewsletter: window.eloquaPrefData.C_Do_Not_Email___Newsletter1,
				});
			}
		}
		setUpdate(true);
	}, []);

	const onInputChange = (e) => {
		if (e.target.type !== 'checkbox') {
			setValues({
				...values,
				[e.target.name]: e.target.value,
			});
		}
		if (e.target.type === 'checkbox') {
			setValues({
				...values,
				[e.target.name]: e.target.checked,
			});
			setUpdate(true);
		}
		if (e.target.name === 'unsubscribe') {
			if (e.target.checked == true) {
				setValues({
					...values,
					[e.target.name]: 1,
				});
			} else {
				setValues({
					...values,
					[e.target.name]: 0,
				});
			}
		}

		setDisabled(false);
		setSuccess(false);
		setUpdate(true);
	};

	const onEmailBlur = (e) => {
		let errors = [];

		if (!isValidEmail(e.target.value)) {
			errors.emailAddress = 'Please enter a valid email address';
		}

		setErrors(errors);
	};

	const validate = (values) => {
		let errors = [];

		if (!isValidEmail(values.emailAddress)) {
			errors.emailAddress = 'Please enter a valid email address';
		}

		return errors;
	};

	const onFormSubmit = (e) => {
		e.preventDefault();

		const errors = validate(values);
		if (Object.keys(errors).length > 0) {
			setErrors(errors);
		} else {
			const data = new FormData(e.target);
			setDisabled(true);
			setErrors({});

			axios
				.post(eloquaTrackingUrl, data)
				.then((res) => {
					if (res.status === 200) {
						setDisabled(false);
					}

					setDisabled(true);
					setSuccess(true);
					setUpdate(true);
				})
				.catch(setDisabled(false));
		}
	};

	return (
		<EloquaForm
			elqFormName='preference-center'
			onFormSubmit={(e) => onFormSubmit(e)}
			className={styles.serviceRequest}
		>
			<Container width={700}>
				<Row>
					<Column xs={12}>
						<div
							className={styles.emailPref_text}
							dangerouslySetInnerHTML={{
								__html: data.subheading,
							}}
						/>
					</Column>

					<Column xs={12}>
						<Checkbox
							id='emailPromo'
							name='emailPromo'
							labelText='Promotional - Occasional emails with special offers, promotions, and more.'
							onChange={onInputChange}
							value={values.emailPromo}
							checked={values.emailPromo}
						/>
					</Column>

					{/* <Column xs={12} >
						<Checkbox
							id='emailPromo'
							labelText='Promotional - Occasional emails about new product launches, exclusive offers, latest innovations, etc. '
							onChange={e => onInputChange(e)}
						/>
					</Column> */}

					<Column xs={12}>
						<Checkbox
							id='emailNewsletter'
							name='emailNewsletter'
							labelText='Newsletters - Occasional emails highlighting new products, innovations and updates across the Pella business.'
							onChange={onInputChange}
							value={values.emailNewsletter}
							checked={values.emailNewsletter}
						/>
					</Column>

					<Column xs={12}>
						<div className={styles.emailPref_text}>If you do not want to receive any emails from Pella, please check the box below.</div>
					</Column>

					<Column xs={12}>
						<Checkbox
							id='unsubscribe'
							name='unsubscribe'
							labelText='Remove me from all Pella email lists '
							onChange={onInputChange}
							value={values.unsubscribe}
							checked={values.unsubscribe === 1 ? true : false}
						/>
					</Column>

					<Column xs={12}>
						<TextInput
							id='emailAddress'
							labelText='Email Address'
							onChange={onInputChange}
							onBlur={onEmailBlur}
							required={true}
							error={errors.emailAddress}
							errorText={errors.emailAddress}
							autoComplete='email'
						/>
					</Column>

					<Column
						xs={12}
						md={6}
					>
						<TextInput
							id='firstName'
							labelText='First Name'
							onChange={onInputChange}
							autoComplete='given-name'
						/>
					</Column>

					<Column
						xs={12}
						md={6}
					>
						<TextInput
							id='lastName'
							labelText='Last Name'
							onChange={onInputChange}
							autoComplete='family-name'
						/>
					</Column>

					<Column xs={12}>
						<TextInput
							id='zipPostal'
							labelText='Zip Code'
							onChange={onInputChange}
							value={values.zipPostal}
							autoComplete='postal-code'
						/>
					</Column>

					<Column xs={12}>
						<Select
							id='customerType'
							labelText='Customer Type'
							onChange={onInputChange}
							value={values.customerType}
							autoComplete='off'
						>
							<option value='0'>Select...</option>
							<option value='Replacement Contractor'>Replacement Contractor</option>
							<option value='Remodeling Contractor'>Remodeling Contractor</option>
							<option value='Residential Builder/GC'>Residential Builder/GC</option>
							<option value='Commercial Builder/GC'>Commercial Builder/GC</option>
							<option value='Architectural / Design Firm'>Architectural / Design Firm</option>
							<option value='Commercial Building Owner'>Commercial Building Owner</option>
							<option value='Homeowner'>Homeowner</option>
						</Select>
					</Column>

					<Column xs={12}>
						<Button
							color='primary'
							type='submit'
							wide={true}
							disabled={disabled}
							className={styles.serviceRequest_SubmitBtn}
						>
							Submit
						</Button>
					</Column>

					{success && (
						<Column xs={12}>
							<div className={styles.serviceRequest_confirmationMsg}>Thank you! We have received your unsubscribe request.</div>
						</Column>
					)}
				</Row>
			</Container>
		</EloquaForm>
	);
};

EmailPreferenceForm.propTypes = {
	data: PropTypes.object,
};

export default EmailPreferenceForm;
